<app-header [showSlider]="false" [navLight]="false"></app-header>
<br>
<br>
<br>
<div class="container">
    <h4 class="mt-5 text-center fs-2">Our Team</h4>
</div>

<br>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-md-10">

            <div class="row justify-content-center">
                <div class="col-6 col-md-3 d-flex flex-column align-items-center mb-4"
                    *ngFor="let t of teamList;let i = index">
                    <img class="rounded-circle img-fluid" [src]="getTeamImage(t)" [alt]="t.name"
                        style="width: 150px; height: 150px; object-fit: cover;" />

                    <div class="text-center mt-3 fs-5 text-primary">
                        {{ t.name }}
                    </div>

                    <div class="text-center fs-6">
                        {{ t.designation }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>



<app-footer></app-footer>